import {
  EMAIL_PROCESSING_STATUS_LOAD_REQUEST,
  EMAIL_PROCESSING_STATUS_RESET,
  EMAIL_PROCESSING_STATUS_SET,
  EMAIL_SETTINGS_CREATE_CONFIG_FAIL,
  EMAIL_SETTINGS_CREATE_CONFIG_REQUEST,
  EMAIL_SETTINGS_CREATE_CONFIG_RESET,
  EMAIL_SETTINGS_CREATE_CONFIG_SUCCESS,
  EMAIL_SETTINGS_CREATE_RULES_FAIL,
  EMAIL_SETTINGS_CREATE_RULES_REQUEST,
  EMAIL_SETTINGS_CREATE_RULES_RESET,
  EMAIL_SETTINGS_CREATE_RULES_SUCCESS,
  EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_FAIL,
  EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_REQUEST,
  EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_RESET,
  EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_SUCCESS,
  EMAIL_SETTINGS_DELETE_RULE_FAIL,
  EMAIL_SETTINGS_DELETE_RULE_REQUEST,
  EMAIL_SETTINGS_DELETE_RULE_SUCCESS,
  EMAIL_SETTINGS_GET_CONFIG_FAIL,
  EMAIL_SETTINGS_GET_CONFIG_REQUEST,
  EMAIL_SETTINGS_GET_CONFIG_RESET,
  EMAIL_SETTINGS_GET_CONFIG_SUCCESS,
  EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_FAIL,
  EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_REQUEST,
  EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_RESET,
  EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_SUCCESS,
  EMAIL_SETTINGS_GET_RULES_FAIL,
  EMAIL_SETTINGS_GET_RULES_REQUEST,
  EMAIL_SETTINGS_GET_RULES_RESET,
  EMAIL_SETTINGS_GET_RULES_SUCCESS,
  EMAIL_SETTINGS_GET_SUBSCRIPTIONS_FAIL,
  EMAIL_SETTINGS_GET_SUBSCRIPTIONS_REQUEST,
  EMAIL_SETTINGS_GET_SUBSCRIPTIONS_RESET,
  EMAIL_SETTINGS_GET_SUBSCRIPTIONS_SUCCESS,
  EMAIL_SETTINGS_SETUP_FAIL,
  EMAIL_SETTINGS_SETUP_REQUEST,
  EMAIL_SETTINGS_SETUP_RESET,
  EMAIL_SETTINGS_SETUP_SUCCESS,
  EMAIL_SETTINGS_UPDATE_CONFIG_FAIL,
  EMAIL_SETTINGS_UPDATE_CONFIG_REQUEST,
  EMAIL_SETTINGS_UPDATE_CONFIG_SUCCESS,
  EMAIL_SETTINGS_UPDATE_RULES_FAIL,
  EMAIL_SETTINGS_UPDATE_RULES_REQUEST,
  EMAIL_SETTINGS_UPDATE_RULES_SUCCESS,
  EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_FAIL,
  EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_REQUEST,
  EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_SUCCESS
} from '@/constants/emailSettingsConstants'

const listInitialState = {
  loading: false,
  items: [],
  total: 0,
  page: 1,
  pages: 0,
  hasNext: false,
  hasPrevious: false,
  single: null,
  error: null
}

// Both list (paginated envelope) and single (id query) responses share the
// same SUCCESS action — pick which property to fill based on payload shape.
const listSuccess = (payload) => {
  if (Array.isArray(payload?.items)) {
    return {
      loading: false,
      items: payload.items,
      total: payload.total ?? payload.items.length,
      page: payload.next_page ? payload.next_page - 1 : (payload.pages ?? 1),
      pages: payload.pages ?? 1,
      hasNext: !!payload.has_next,
      hasPrevious: !!payload.has_previous,
      single: null,
      error: null
    }
  }
  return { ...listInitialState, single: payload, loading: false }
}

// ──────────────────────────────────────────────────────────────────────────
// Config
// ──────────────────────────────────────────────────────────────────────────
export const emailIngestionConfigsReducer = (state = listInitialState, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_GET_CONFIG_REQUEST:
      return { ...state, loading: true, error: null }
    case EMAIL_SETTINGS_GET_CONFIG_SUCCESS:
      return listSuccess(action.payload)
    case EMAIL_SETTINGS_GET_CONFIG_FAIL:
      return { ...state, loading: false, error: action.payload }
    case EMAIL_SETTINGS_GET_CONFIG_RESET:
      return listInitialState
    default:
      return state
  }
}

export const emailIngestionConfigCreateReducer = (state = { loading: false, data: null, error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_CREATE_CONFIG_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_CREATE_CONFIG_SUCCESS:
      return { loading: false, data: action.payload, error: null, success: true }
    case EMAIL_SETTINGS_CREATE_CONFIG_FAIL:
      return { loading: false, data: null, error: action.payload, success: false }
    case EMAIL_SETTINGS_CREATE_CONFIG_RESET:
      return { loading: false, data: null, error: null, success: false }
    default:
      return state
  }
}

export const emailIngestionConfigUpdateReducer = (state = { loading: false, data: null, error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_UPDATE_CONFIG_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_UPDATE_CONFIG_SUCCESS:
      return { loading: false, data: action.payload, error: null, success: true }
    case EMAIL_SETTINGS_UPDATE_CONFIG_FAIL:
      return { loading: false, data: null, error: action.payload, success: false }
    default:
      return state
  }
}

// ──────────────────────────────────────────────────────────────────────────
// Rules
// ──────────────────────────────────────────────────────────────────────────
export const emailIngestionRulesReducer = (state = listInitialState, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_GET_RULES_REQUEST:
      return { ...state, loading: true, error: null }
    case EMAIL_SETTINGS_GET_RULES_SUCCESS:
      return listSuccess(action.payload)
    case EMAIL_SETTINGS_GET_RULES_FAIL:
      return { ...state, loading: false, error: action.payload }
    case EMAIL_SETTINGS_GET_RULES_RESET:
      return listInitialState
    default:
      return state
  }
}

export const emailIngestionRuleCreateReducer = (state = { loading: false, results: [], error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_CREATE_RULES_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_CREATE_RULES_SUCCESS:
      return { loading: false, results: action.payload?.results || [], error: null, success: true }
    case EMAIL_SETTINGS_CREATE_RULES_FAIL:
      return { loading: false, results: [], error: action.payload, success: false }
    case EMAIL_SETTINGS_CREATE_RULES_RESET:
      return { loading: false, results: [], error: null, success: false }
    default:
      return state
  }
}

export const emailIngestionRuleUpdateReducer = (state = { loading: false, data: null, error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_UPDATE_RULES_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_UPDATE_RULES_SUCCESS:
      return { loading: false, data: action.payload, error: null, success: true }
    case EMAIL_SETTINGS_UPDATE_RULES_FAIL:
      return { loading: false, data: null, error: action.payload, success: false }
    default:
      return state
  }
}

export const emailIngestionRuleDeleteReducer = (state = { loading: false, deletedId: null, error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_DELETE_RULE_REQUEST:
      return { ...state, loading: true, error: null, success: false, deletedId: action.payload?.id ?? null }
    case EMAIL_SETTINGS_DELETE_RULE_SUCCESS:
      return { loading: false, deletedId: action.payload?.id ?? state.deletedId, error: null, success: true }
    case EMAIL_SETTINGS_DELETE_RULE_FAIL:
      return { loading: false, deletedId: null, error: action.payload, success: false }
    default:
      return state
  }
}

// ──────────────────────────────────────────────────────────────────────────
// Subscriptions
// ──────────────────────────────────────────────────────────────────────────
export const emailSubscriptionsReducer = (state = listInitialState, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_GET_SUBSCRIPTIONS_REQUEST:
      return { ...state, loading: true, error: null }
    case EMAIL_SETTINGS_GET_SUBSCRIPTIONS_SUCCESS:
      return listSuccess(action.payload)
    case EMAIL_SETTINGS_GET_SUBSCRIPTIONS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case EMAIL_SETTINGS_GET_SUBSCRIPTIONS_RESET:
      return listInitialState
    default:
      return state
  }
}

export const emailSubscriptionCreateReducer = (state = { loading: false, results: [], error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_SUCCESS:
      return { loading: false, results: action.payload?.results || [], error: null, success: true }
    case EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_FAIL:
      return { loading: false, results: [], error: action.payload, success: false }
    case EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_RESET:
      return { loading: false, results: [], error: null, success: false }
    default:
      return state
  }
}

export const emailSubscriptionUpdateReducer = (state = { loading: false, data: null, error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_SUCCESS:
      return { loading: false, data: action.payload, error: null, success: true }
    case EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_FAIL:
      return { loading: false, data: null, error: action.payload, success: false }
    default:
      return state
  }
}

// ──────────────────────────────────────────────────────────────────────────
// Setup (combined)
// ──────────────────────────────────────────────────────────────────────────
export const emailIngestionSetupReducer = (state = { loading: false, data: null, error: null, success: false }, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_SETUP_REQUEST:
      return { ...state, loading: true, error: null, success: false }
    case EMAIL_SETTINGS_SETUP_SUCCESS:
      return { loading: false, data: action.payload, error: null, success: true }
    case EMAIL_SETTINGS_SETUP_FAIL:
      return { loading: false, data: null, error: action.payload, success: false }
    case EMAIL_SETTINGS_SETUP_RESET:
      return { loading: false, data: null, error: null, success: false }
    default:
      return state
  }
}

// ──────────────────────────────────────────────────────────────────────────
// Email processing on/off cache — drives gating of UI like the quote-screen
// "Add to email rules" button. `loaded` distinguishes "haven't fetched yet"
// from "fetched and found off" so consumers don't flicker the button.
// ──────────────────────────────────────────────────────────────────────────
const emailProcessingStatusInitial = { loading: false, loaded: false, enabled: false }

export const emailProcessingStatusReducer = (state = emailProcessingStatusInitial, action) => {
  switch (action.type) {
    case EMAIL_PROCESSING_STATUS_LOAD_REQUEST:
      return { ...state, loading: true }
    case EMAIL_PROCESSING_STATUS_SET:
      return { loading: false, loaded: true, enabled: !!action.payload }
    case EMAIL_PROCESSING_STATUS_RESET:
      return emailProcessingStatusInitial
    default:
      return state
  }
}

// ──────────────────────────────────────────────────────────────────────────
// Mailbox folders (GraphAPI list_mail_folders)
// ──────────────────────────────────────────────────────────────────────────
export const mailboxFoldersReducer = (state = listInitialState, action) => {
  switch (action.type) {
    case EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_REQUEST:
      return { ...state, loading: true, error: null }
    case EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_SUCCESS:
      return listSuccess(action.payload)
    case EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_FAIL:
      return { ...state, loading: false, error: action.payload }
    case EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_RESET:
      return listInitialState
    default:
      return state
  }
}
